var map = {
	"./add.svg": "76a4",
	"./arrow-down.svg": "c874",
	"./arrow-header.svg": "760f",
	"./arrow-left.svg": "ac3b",
	"./arrow-right-grey.svg": "5d30",
	"./arrow-right.svg": "cd8c",
	"./baloon.svg": "9e74",
	"./bloquote.svg": "5875",
	"./card.svg": "5d4a",
	"./chat.svg": "9b69",
	"./chat/doc.svg": "9e3a",
	"./chat/paperclip.svg": "39c8",
	"./chat/read.svg": "ddec",
	"./chat/send.svg": "d1f9",
	"./chat/sent.svg": "ac0c",
	"./chevron-down.svg": "1755",
	"./chevron-up.svg": "bb5d",
	"./clock.svg": "755b",
	"./close-light.svg": "3b0a",
	"./close.svg": "8b1b",
	"./color-unselect.svg": "9826",
	"./comparison-green.svg": "ada1",
	"./comparison.svg": "5d8a",
	"./dark-like-active.svg": "e0b2",
	"./dark-like.svg": "8add",
	"./delete.svg": "0d45",
	"./doc.svg": "3f7d",
	"./doc_success.svg": "9ff0",
	"./dots.svg": "93d2",
	"./down.svg": "d8aa",
	"./download.svg": "f28e",
	"./eclipse-menu.svg": "b84b",
	"./edit.svg": "daf0",
	"./full-line.svg": "478a",
	"./heart.svg": "7d16",
	"./info.svg": "76ed",
	"./like.svg": "6d8b",
	"./logistics.svg": "39e6",
	"./mag.svg": "9b81",
	"./main.svg": "7895",
	"./menu.svg": "d17f",
	"./minus.svg": "3e24",
	"./package.svg": "d07a",
	"./plus.svg": "eb38",
	"./products.svg": "dafa",
	"./progress-line.svg": "6843",
	"./purchases.svg": "97bc",
	"./pushpin.svg": "b6ab",
	"./question.svg": "9872",
	"./quote.svg": "1636",
	"./rate_add.svg": "3279",
	"./reload.svg": "b9c2",
	"./repair.svg": "ab9e",
	"./salies.svg": "0df8",
	"./setting.svg": "5de8",
	"./shopping-cart.svg": "b15e",
	"./sidebar/active/blog.svg": "9b3f",
	"./sidebar/active/chat.svg": "b6fd",
	"./sidebar/active/logistics.svg": "64f2",
	"./sidebar/active/mag.svg": "93a3",
	"./sidebar/active/main.svg": "8aa0",
	"./sidebar/active/offer.svg": "2f4e",
	"./sidebar/active/products.svg": "9d64",
	"./sidebar/active/purchases.svg": "237a",
	"./sidebar/active/salies.svg": "5041",
	"./sidebar/active/shops.svg": "2578",
	"./sidebar/active/staff.svg": "2db3",
	"./sidebar/active/suggestions.svg": "75dd",
	"./sidebar/blog.svg": "0d83",
	"./sidebar/chat.svg": "7877",
	"./sidebar/logistics.svg": "ea6e",
	"./sidebar/mag.svg": "737e",
	"./sidebar/main.svg": "a098",
	"./sidebar/notepad.svg": "db63",
	"./sidebar/offer.svg": "d91a",
	"./sidebar/products.svg": "c676",
	"./sidebar/purchases.svg": "ddf4",
	"./sidebar/salies.svg": "1718",
	"./sidebar/shops.svg": "c8a4",
	"./sidebar/staff.svg": "88fb",
	"./sidebar/suggestions.svg": "a7ac",
	"./staff.svg": "d32e",
	"./star-grey.svg": "4079",
	"./star-orange.svg": "d930",
	"./suggestions.svg": "2a54",
	"./trash.svg": "af22",
	"./trash_restore.svg": "ee26",
	"./trash_white.svg": "9a2e",
	"./tree/arrow.svg": "532e",
	"./tree/folder.svg": "f738",
	"./tree/folder_active.svg": "242c",
	"./up.svg": "5c5b",
	"./user-nav.svg": "9698",
	"./user.svg": "6aed",
	"./verification.svg": "0f85",
	"./video_youtube.svg": "190c",
	"./view-list.svg": "641c",
	"./view-table.svg": "d006",
	"./views.svg": "cd0b",
	"./warning.svg": "daa9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";